package com.shmbles.web.components

import androidx.compose.runtime.Composable
import com.shmbles.web.models.Company
import com.shmbles.web.models.Theme
import com.shmbles.web.styles.CompanyCardStyle
import com.shmbles.web.util.Constants.FONT_FAMILY
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun CompanyCard(modifier: Modifier = Modifier, company: Company) {
    Column(
        modifier = CompanyCardStyle.toModifier()
            .then(modifier)
            .padding(leftRight = 15.px, topBottom = 15.px),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Box(
            modifier = Modifier
                .height(75.px)
                .fillMaxWidth()
                .padding(
                    leftRight = if (company.darkBackground) 8.px else 0.px,
                    topBottom = if (company.darkBackground) 4.px else 0.px
                )
                .borderRadius(r = 6.px)
                .backgroundColor(if (company.darkBackground) Theme.Secondary.rgb else Colors.Transparent),
            contentAlignment = Alignment.Center
        ) {
            Image(
                modifier = Modifier
                    .width(185.px)
                    .height(65.px)
                    .objectFit(ObjectFit.Contain),
                src = company.logo,
                description = "${company.companyName} Logo"
            )
        }
        P(
            attrs = Modifier
                .margin(top = 10.px, bottom = 0.px)
                .fontFamily(FONT_FAMILY)
                .fontSize(14.px)
                .fontWeight(FontWeight.Normal)
                .color(Theme.Secondary.rgb)
                .toAttrs()
        ) {
            Text(company.role)
        }
    }
}
